import {createStyles, makeStyles} from "@material-ui/core/styles";
import React from "react";
import {Helmet} from "react-helmet";

import R from "resources/Namespace";
import NavBar from "components/navigation_bar/NavBar";

import NestedLoader from "./NestedLoader";
import {IFullPageLoaderProps} from "./types";

const useStyles = makeStyles(() =>
    createStyles({
        "@global": {
            html: {
                height: "100%",
            },
            body: {
                height: "100%",
            },
            "body #root": {
                height: "100%",
            },
        },
    }),
);

/**
 * Use this component when you want to show a full page loading spinner indicating we are
 * loading something
 */
function FullPageLoader(props: IFullPageLoaderProps) {
    useStyles();

    return (
        <>
            <Helmet>
                <title>{`${R.strings.loader.loading} · ${R.strings.app.name}`}</title>
                <meta name="description" content={R.strings.app.description} />

                <meta property="og:title" content={`${R.strings.loader.loading} · ${R.strings.app.name}`} />
                <meta property="og:description" content={R.strings.app.description} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content={R.strings.app.name_with_tld} />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:site" content={R.strings.app.flux_twitter_handle} />
                <meta name="twitter:title" content={`Loading · ${R.strings.app.name}`} />
                <meta name="twitter:description" content={R.strings.app.description} />
            </Helmet>

            {props.showNavBar && <NavBar position="relative" mode={"blank"} />}

            <NestedLoader
                caller={"FullPageLoader"}
                surface={props.surface}
                content={props.content}
                delay={props.delay}
                showLongWaitExcuse={props.showLongWaitExcuse}
                bodyContent={props?.bodyContent}
                showWithNavbarOffset={props.showNavBar}
            />
        </>
    );
}

export default React.memo(FullPageLoader);
